import { motion } from 'framer-motion';

export default function EffectsSection() {
  const effects = [
    {
      icon: 'ri-links-line',
      title: 'Conexiones Dinámicas',
      description: 'Líneas luminosas que conectan elementos en tiempo real creando una red visual interactiva',
      color: 'cyan'
    },
    {
      icon: 'ri-box-3-line',
      title: 'Tarjetas Holográficas',
      description: 'Elementos UI que rotan en 3D al hacer hover con efectos de profundidad y glassmorphism',
      color: 'purple'
    },
    {
      icon: 'ri-space-ship-line',
      title: 'Fondo Espacial',
      description: 'Partículas que forman patrones de dinámica de flujo con movimiento orbital continuo',
      color: 'pink'
    },
    {
      icon: 'ri-orbit-line',
      title: 'Transiciones Orbitales',
      description: 'Navegación con movimientos de cámara 3D que crean experiencias cinematográficas',
      color: 'yellow'
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Visualización de Datos',
      description: 'Gráficos que emergen del plano con profundidad volumétrica y animaciones fluidas',
      color: 'green'
    },
    {
      icon: 'ri-magic-line',
      title: 'Efectos Luminosos',
      description: 'Shaders personalizados que generan brillos, reflejos y emisiones de luz realistas',
      color: 'blue'
    }
  ];

  return (
    <section id="ecosystem" className="relative py-32 bg-black">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/4bf98e180dc48d832d13f04b04017e5b.jpg')] opacity-5 bg-cover bg-center"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="bg-gradient-to-r from-cyan-400 via-purple-500 to-pink-500 bg-clip-text text-transparent">
              Efectos 3D Clave NEXUS
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Tecnología de vanguardia que transforma cada interacción en una experiencia inmersiva
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {effects.map((effect, index) => (
            <motion.div
              key={effect.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group relative"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-purple-500/10 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
              <div className="relative h-full p-8 rounded-3xl bg-gradient-to-br from-gray-900/50 to-gray-800/50 border border-gray-800 group-hover:border-cyan-500/50 backdrop-blur-sm transition-all duration-500 transform group-hover:scale-105">
                <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br from-${effect.color}-400/20 to-${effect.color}-600/20 border border-${effect.color}-500/30 flex items-center justify-center mb-6 transform group-hover:rotate-12 transition-transform duration-500`}>
                  <i className={`${effect.icon} text-3xl text-${effect.color}-400`}></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-4">{effect.title}</h3>
                <p className="text-gray-400 leading-relaxed">{effect.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-20 text-center"
        >
          <a
            href="#packages"
            className="inline-block px-8 py-4 rounded-full bg-gradient-to-r from-cyan-500 to-purple-600 text-white font-semibold text-lg hover:shadow-2xl hover:shadow-cyan-500/50 transition-all duration-300 transform hover:scale-105 whitespace-nowrap"
          >
            Descubre los Paquetes
          </a>
        </motion.div>
      </div>
    </section>
  );
}
